import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'

Vue.component('app-pessoa-grid', grid)
Vue.component('app-pessoa-edit', edit)
